
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 79.568 79.613"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#8CC63F"}},[_c('path',{attrs:{"d":"M0 32.319L19.892 0l19.892 32.319z"}}),_c('path',{attrs:{"d":"M0 54.784l19.892-32.319 19.892 32.319z"}}),_c('path',{attrs:{"d":"M0 79.613l19.892-32.318 19.892 32.318z"}}),_c('g',[_c('path',{attrs:{"d":"M39.784 32.319L59.676 0l19.892 32.319z"}}),_c('path',{attrs:{"d":"M39.784 54.784l19.892-32.319 19.892 32.319z"}}),_c('path',{attrs:{"d":"M39.784 79.613l19.892-32.318 19.892 32.318z"}})])])])
          )
        }
      }
    